import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { product, purchases } from '../data/salesCopy';
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 5000);
    };
    const first = setTimeout(show, 3000);
    const interval = setInterval(show, 15000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed right-3 top-3 z-50 animate-pop-in" role="status" aria-live="polite" data-id="element-215" data-mp="1cxlm179sakn6">
      <div className="relative max-w-[270px] overflow-hidden rounded-lg border-2 border-brand-clay bg-white p-2.5 pr-7 shadow-2xl" data-id="element-216" data-mp="1gzozg1g0jzb3">
        <span className="absolute left-0 top-0 h-1 w-full bg-brand-gold" data-id="element-217" data-mp="164eiug87bsnf" />
        <button type="button" onClick={() => setVisible(false)} className="absolute right-1 top-1 rounded p-1 text-brand-taupe transition-colors duration-150 ease-smooth hover:text-brand-charcoal" aria-label="Close notification" data-id="element-218" data-mp="117o1lpknur0f">
          <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-219" data-mp="n6vazfxhcg2l" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-220" data-mp="n8y4i9xucrc2">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-brand-clay/40 bg-brand-clay/10 text-brand-clay" data-id="element-221" data-mp="i9btm75hjn6f">
            <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-222" data-mp="s67ubqp5750f" />
          </span>
          <div className="leading-tight" data-id="element-223" data-mp="s8kjantbifmz">
            <p className="text-[13px] font-bold text-brand-charcoal" data-id="element-224" data-mp="28joglx5desfg">
              {current.name}
            </p>
            <p className="text-[10px] font-semibold text-brand-taupe" data-id="element-225" data-mp="23kleolkot2bp">
              {current.city}, {current.country}
            </p>
            <p className="mt-0.5 text-[11px] font-extrabold text-brand-sage" data-id="element-226" data-mp="2aqxlsogkcif9">
              just purchased {product.name}
            </p>
          </div>
        </div>
      </div>
    </div>;
}